import { PayloadAction } from '@reduxjs/toolkit';
import { ChannelSettingsReducerCreator } from '../types';

const setShowEditChannelDetailsModalReducer = (create: ChannelSettingsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.showEditChannelDetailsModal = action.payload;
  });
};

export default setShowEditChannelDetailsModalReducer;
